import { render, staticRenderFns } from "./major_analyze.vue?vue&type=template&id=3052cbd3&scoped=true"
import script from "./major_analyze.vue?vue&type=script&lang=js"
export * from "./major_analyze.vue?vue&type=script&lang=js"
import style0 from "./major_analyze.vue?vue&type=style&index=0&id=3052cbd3&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052cbd3",
  null
  
)

export default component.exports